import { CplItem } from './cpl-item.model';

export class CplItemDuplicateData{
    ItemModel: CplItem;
    Title: string;
    ShouldDuplicateRoster: boolean;
    QfmId: string;
    QfmTitle: string;
}